<template>
  <div class="bind-teacher-container">
    <el-card class="bind-teacher-card">
      <div slot="header" class="bind-teacher-header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goToHome" class="back-button">返回</el-button>
        <h2>加入班级</h2>
        <div class="teacher-info" v-if="teacherInfo">
          尊敬的{{ teacherInfo.nickname }}，<br>您已绑定{{ boundClassCount }}个班级，一位老师最多绑定{{ maxClasses }}个班级
        </div>
      </div>
      
      <form class="bind-teacher-form">
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 80px;">班级<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 80px;">
            <el-input 
              v-model="fullClassName" 
              :disabled="true"
              :style="inputStyle"
              placeholder="班级" />
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 80px;">任教科目<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 80px;">
            <el-select 
              v-model="subjectId" 
              :disabled="true"
              :style="inputStyle"
              style="width: 100%;"
              placeholder="任教科目">
              <el-option
                v-for="subject in subjects"
                :key="subject.id"
                :label="subject.name"
                :value="subject.id">
              </el-option>
            </el-select>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 80px;">作业类型<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 80px;">
            <div class="homework-types-container">
              <el-tree
                class="homework-types-tree"
                :data="treeData"
                :props="defaultProps"
                :expand-on-click-node="false"
                node-key="id"
                highlight-current
                :default-expanded-keys="expandedKeys">
                <span class="custom-tree-node" slot-scope="{ node, data }" style="display: flex; align-items: center; justify-content: space-between; font-size: 14px; width: 100%;">
                  <span class="node-label" style="flex: 1; min-width: 0;">{{ node.label }}</span>
                  <span v-if="data.type === 'subject'" class="node-actions" style="margin-left: 10px; display: flex; align-items: center;">
                    <el-button
                      type="text"
                      size="mini"
                      :disabled="isHomeworkTypeLimitReached(data)"
                      @click="() => showAddHomeworkTypeDialog(data)">
                      添加作业类型
                    </el-button>
                  </span>
                  <span v-else class="node-actions" style="margin-left: 10px; display: flex; align-items: center;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="() => renameNode(node, data)">
                      重命名
                    </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="() => moveUp(node, data)">
                      上移
                    </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="() => moveDown(node, data)">
                      下移
                    </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="() => remove(node, data)">
                      删除
                    </el-button>
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 80px;"></label>
          <div class="el-form-item__content" style="margin-left: 80px;">
            <el-button 
              type="primary" 
              @click="joinClass"
              :loading="joining"
              style="width: 100%; border-radius: 10px;">
              加入班级
            </el-button>
          </div>
        </div>
      </form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BindTeacherMobile',
  data() {
    return {
      code: '',
      className: '',
      classNumber: '',
      fullClassName: '',
      subjectId: '',
      teacherInfo: null,
      boundClassCount: 0,
      maxClasses: 5,
      subjects: [
        { id: 1, name: '语文' },
        { id: 2, name: '数学' },
        { id: 3, name: '英语' }
      ],
      chineseNumbers: {
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '七',
        '8': '八',
        '9': '九',
        '10': '十'
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      expandedKeys: [],
      joining: false,
      currentParentData: null
    }
  },
  computed: {
    inputStyle() {
      return {
        fontSize: '16px',
        fontWeight: 'bold'
      };
    }
  },
  async mounted() {
    // 设置body的padding为0
    document.body.classList.add('mobile-view');
    document.body.classList.add('no-padding');
    document.body.style.padding = '0';
    
    // 获取教师信息
    try {
      const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo'));
      if (teacherInfo) {
        this.teacherInfo = teacherInfo;
      } else {
        // 尝试获取当前登录教师的信息来验证token
        const response = await this.$http.get('/teachers/profile');
        if (response.data.success) {
          this.teacherInfo = response.data.teacher;
          localStorage.setItem('teacherInfo', JSON.stringify(this.teacherInfo));
        }
      }
      
      if (this.teacherInfo) {
        await this.fetchClassCounts();
      }
    } catch (error) {
      console.error('获取教师信息失败:', error);
    }
    
    this.code = this.$route.query.code;
    if (this.code) {
      this.fetchClassInfo();
    } else {
      this.$message.error('缺少必要的code参数');
    }
  },
  beforeDestroy() {
    // 在组件销毁前恢复body的padding
    document.body.classList.remove('mobile-view');
    document.body.classList.remove('no-padding');
    document.body.style.padding = '';
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    
    async fetchClassCounts() {
      try {
        const response = await this.$http.get(`/teachers/hasClass`);
        if (response.data && response.data.success) {
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        } else {
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        }
      } catch (error) {
        console.error('获取教师班级数量失败:', error);
        this.boundClassCount = 0;
        this.maxClasses = 5;
      }
    },
    
    async fetchClassInfo() {
      try {
        const response = await this.$http.get(`/teacherBinding/getClassInfo?code=${this.code}`);
        if (response.data.success) {
          this.className = response.data.classInfo.className;
          this.classNumber = response.data.classInfo.classNumber;
          const match = this.className.match(/第(\d+)级/);
          const gradeNumber = match ? match[1] : '';
          this.fullClassName = `${this.chineseNumbers[gradeNumber] || gradeNumber}(${this.classNumber})班`;
          this.subjectId = response.data.classInfo.subjectId;
          this.initializeHomeworkTypesTree(response.data.classInfo.subjectId);
        } else {
          this.$message.error(response.data.message || '获取班级信息失败');
        }
      } catch (error) {
        console.error('获取班级信息失败:', error);
        this.$message.error('获取班级信息失败');
      }
    },
    
    initializeHomeworkTypesTree(subjectId) {
      const subjectName = this.subjects.find(sub => sub.id === subjectId)?.name || '未知科目';
      
      let defaultTypes = [];
      if (subjectId === 1) { // 语文
        defaultTypes = [{ name: '听写本' }];
      } else if (subjectId === 2) { // 数学
        defaultTypes = [{ name: '计算题' }];
      } else if (subjectId === 3) { // 英语
        defaultTypes = [{ name: '听写本' }];
      } else { // 其他科目
        defaultTypes = [];
      }
      
      this.treeData = [{
        id: `subject_${subjectId}`,
        label: subjectName,
        type: 'subject',
        children: defaultTypes.map((type, index) => ({
          id: `type_${index}`,
          label: type.name,
          type: 'homework-type'
        }))
      }];
      
      this.expandedKeys = [`subject_${subjectId}`];
    },
    
    // 查找节点的父节点
    findParentNode(treeData, targetNode) {
      for (let i = 0; i < treeData.length; i++) {
        const item = treeData[i];
        if (item.children) {
          if (item.children.some(child => child.id === targetNode.id)) {
            return item;
          }
          // 递归查找
          const found = this.findParentNode(item.children, targetNode);
          if (found) return found;
        }
      }
      return null;
    },
    
    showAddHomeworkTypeDialog(parentData) {
      this.$prompt('请输入作业类型名称', '添加作业类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入作业类型名称',
        inputValidator: (value) => {
          if (!value || value.trim() === '') return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentData.children && parentData.children.some(child => child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确',
        closeOnClickModal: false
      }).then(({ value }) => {
        if (!parentData.children) {
          this.$set(parentData, 'children', []);
        }
        
        const newType = {
          id: `type_${Date.now()}`,
          label: value.trim(),
          type: 'homework-type'
        };
        
        parentData.children.push(newType);
        this.$message.success('作业类型添加成功');
      }).catch(() => {
        // 用户取消操作
      });
    },
    
    renameNode(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      
      this.$prompt('请输入新的作业类型名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.label,
        inputValidator: (value) => {
          if (!value) return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentNode && parentNode.children && 
              parentNode.children.some(child => child.id !== data.id && child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确'
      }).then(({ value }) => {
        data.label = value;
      }).catch(() => {
        // 取消操作
      });
    },
    
    moveUp(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }
      
      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);
      
      if (index > 0) {
        // 上移：与前一个元素交换位置
        [siblings[index - 1], siblings[index]] = [siblings[index], siblings[index - 1]];
        
        // 创建新的treeData副本以强制更新视图
        this.treeData = [...this.treeData];
      } else {
        this.$message.warning('此项已在顶部，无法上移');
      }
    },
    
    moveDown(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }
      
      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);
      
      if (index < siblings.length - 1) {
        // 下移：与后一个元素交换位置
        [siblings[index], siblings[index + 1]] = [siblings[index + 1], siblings[index]];
        
        // 创建新的treeData副本以强制更新视图
        this.treeData = [...this.treeData];
      } else {
        this.$message.warning('此项已在底部，无法下移');
      }
    },
    
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      
      if (index !== -1) {
        children.splice(index, 1);
      }
    },
    isHomeworkTypeLimitReached(subjectData) {
      if (!subjectData.children) {
        return false;
      }
      return subjectData.children.length >= 20;
    },
    
    async joinClass() {
      if (!this.className || !this.classNumber || !this.subjectId || !this.fullClassName) {
        this.$message.error('班级信息不完整');
        return;
      }
      
      this.joining = true;
      
      try {
        // 收集作业类型信息
        const homeworkTypes = [];
        if (this.treeData && this.treeData.length > 0) {
          // 遍历树数据，收集所有作业类型
          const collectHomeworkTypes = (nodes, currentIndex = 0) => {
            nodes.forEach(node => {
              if (node.type === 'homework-type') {
                // 只有作业类型节点才添加到列表
                homeworkTypes.push({
                  name: node.label,
                  subjectId: this.subjectId,
                  sortOrder: currentIndex + 1
                });
                currentIndex++;
              } else if (node.children && node.children.length > 0) {
                // 如果有子节点，递归遍历
                currentIndex = collectHomeworkTypes(node.children, currentIndex);
              }
            });
            return currentIndex;
          };
          collectHomeworkTypes(this.treeData);
        }
        
        const requestData = {
          code: this.code,
          homeworkTypes: homeworkTypes
        };
        
        const response = await this.$http.post('/teacherBinding/joinClass', requestData);
        if (response.data.success) {
          this.$message.success('成功加入班级！');
          // 跳转到班级主页的对应科目，并将日期更新为今天
          this.$router.push({ 
            name: 'MobileClassHome', 
            params: { classId: response.data.classId },
            query: { subjectId: this.subjectId, date: new Date().toISOString().split('T')[0] }
          });
        } else {
          this.$message.error(response.data.message || '加入班级失败');
        }
      } catch (error) {
        console.error('加入班级失败:', error);
        this.$message.error('加入班级失败');
      } finally {
        this.joining = false;
      }
    }
  }
}
</script>

<style scoped>
.bind-teacher-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #e0f7fa, #b2ebf2);
  padding: 20px 10px; /* 上下20px，左右10px */
}

.bind-teacher-card {
  width: 100%;
  max-width: 600px;
  border-radius: 15px;
  overflow: hidden;
}

/* 设置el-card__body的左右padding为10px */
:deep(.el-card__body) {
  padding: 20px 10px; /* 上下20px，左右10px */
}



.bind-teacher-header {
  background: linear-gradient(90deg, #00bcd4, #4dd0e1);
  color: white;
  padding: 20px;
  margin: -20px -20px 20px -20px;
}

.bind-teacher-header h2 {
  margin: 10px 0 0 0;
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.back-button {
  color: white;
  padding: 0;
  font-size: 14px;
}

.back-button:hover {
  color: #ffffff;
}

.teacher-info {
  margin-top: 10px;
  font-size: 14px;
  color: #fff;
  opacity: 0.9;
  text-align: center;
}

.bind-teacher-form {
  padding: 0px;
}

.homework-types-container {
  width: 100%;
}

.homework-types-tree {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding: 10px 0px 10px 0px; /* 只去掉左右padding，保留上下padding */
  max-height: 300px;
  overflow-y: auto;
  margin-top: 5px;
}

/* 输入框样式增强 - 保持与项目规范一致 */
:deep(.el-input__inner) {
  font-size: 16px !important;
  font-weight: bold !important;
}

:deep(.el-select .el-input__inner) {
  font-size: 16px !important;
  font-weight: bold !important;
}

/* Element UI 表单样式 */
.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}

.el-form-item__content::after {
  clear: both;
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.el-form-item__required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

/* 自定义树节点样式 */
:deep(.custom-tree-node) {
  flex: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  font-size: 14px;
  padding-right: 8px;
  width: 100% !important;
  min-width: 0; /* 确保flex项目可以缩小 */
}

:deep(.node-label) {
  flex: 1 !important;
  min-width: 0 !important; /* 允许文本缩小时收缩 */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

:deep(.node-actions) {
  margin-left: 10px;
  display: flex !important;
  align-items: center !important;
}
</style>